export default __webpack_public_path__ + "static/media/AUM-Logo.a0599932.png";